import { Prettify } from "blocks/components/types";
import { EditProps } from "blocks/types";
import { useEffect } from "react";

const useClientId = (props: Prettify<EditProps<any>>) => {
	const { attributes, setAttributes, name, clientId } = props;

	useEffect(() => {
		const id = clientId.substring(0, 8);
		const [, blockName = "mzb"] = name.split("/");

		if (!attributes.clientId) {
			setAttributes({ clientId: id });
		} else if (attributes.clientId !== id) {
			if (
				document.querySelectorAll(
					`.mzb-${blockName}-${attributes.clientId}`
				).length > 1
			) {
				setAttributes({ clientId: id });
			}
		}
	}, [clientId, name, attributes.clientId, setAttributes]);

	return { clientId: attributes.clientId };
};

export default useClientId;
